import React from "react";
import { TestTube2, Sparkles, ShieldCheck, TrendingUp } from "lucide-react";

const capabilities = [
  { icon: <TestTube2 className="w-5 h-5" />, title: "Desarrollo a medida", desc: "Formulación personalizada según las necesidades y el posicionamiento de cada marca cliente." },
  { icon: <Sparkles className="w-5 h-5" />, title: "Sabores ya desarrollados", desc: "Amplio catálogo de sabores validados y listos para incorporar a nuevas fórmulas." },
  { icon: <ShieldCheck className="w-5 h-5" />, title: "Estabilidad y eficacia", desc: "Fórmulas diseñadas para garantizar la estabilidad del producto y la eficacia de los activos." },
  { icon: <TrendingUp className="w-5 h-5" />, title: "Mejora continua", desc: "Alta calidad y pureza a precios asequibles, para que recibas tus productos con la mayor calidad y excelencia." },
];

const LAB_IMG = "https://images.pexels.com/photos/3735709/pexels-photo-3735709.jpeg?auto=compress&cs=tinysrgb&w=1600";
const LAB_IMG_2 = "https://images.pexels.com/photos/3735747/pexels-photo-3735747.jpeg?auto=compress&cs=tinysrgb&w=1200";
const LAB_IMG_3 = "https://images.pexels.com/photos/3735780/pexels-photo-3735780.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function ResearchLab() {
  return (
    <section id="idi" className="relative py-10 md:py-14 bg-[#F8FAFC] border-y border-slate-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5 flex flex-col">
            <div className="relative flex-1 min-h-[300px] rounded-sm overflow-hidden border border-slate-200 shadow-xl">
              <img src={LAB_IMG} alt="Departamento de I+D y formulación de Global Nutralabs" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/85 via-[#0A1628]/20 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="text-xs uppercase tracking-[0.3em] text-[#5DB2F0] font-semibold">Departamento I+D</div>
                <div className="mt-2 font-display text-2xl md:text-3xl font-bold text-white">Ciencia detrás de cada scoop.</div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              <div className="relative rounded-sm overflow-hidden border border-slate-200 shadow-md h-40">
                <img src={LAB_IMG_2} alt="Análisis de laboratorio" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 to-transparent" />
                <div className="absolute bottom-3 left-3 text-[10px] uppercase tracking-widest text-white font-semibold">Control de calidad</div>
              </div>
              <div className="relative rounded-sm overflow-hidden border border-slate-200 shadow-md h-40">
                <img src={LAB_IMG_3} alt="Pruebas de estabilidad" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 to-transparent" />
                <div className="absolute bottom-3 left-3 text-[10px] uppercase tracking-widest text-white font-semibold">Pruebas de estabilidad</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 08 · Innovación</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
              I+D y desarrollo
              <br />
              <span className="text-[#0A84E2]">de fórmulas.</span>
            </h2>
            <p className="mt-6 text-slate-600 text-lg max-w-2xl">
              Contamos con un <span className="text-[#0A1628] font-semibold">departamento de I+D y formulación propio</span>, enfocado en el diseño de fórmulas eficaces, saborizadas y estables. No solo fabricamos: investigamos, desarrollamos e innovamos junto a cada marca.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-4 flex-1 auto-rows-fr">
              {capabilities.map((c, i) => (
                <div key={i} data-testid={`idi-cap-${i}`} className="corp-card rounded-sm p-5 flex gap-4 h-full items-start">
                  <div className="w-10 h-10 flex-shrink-0 rounded-sm bg-[#0A84E2]/10 border border-[#0A84E2]/30 text-[#0A84E2] flex items-center justify-center">
                    {c.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-base font-semibold text-[#0A1628]">{c.title}</h3>
                    <p className="mt-1 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
